module.exports = __webpack_public_path__ + "img/item_Story_27.407eb5d2.jpeg";